import { createSlice } from "@reduxjs/toolkit";

const loginsclice = createSlice({
  name: "login",
  initialState: {
    loading: false,
    Seller: null,
    error: null,
  },
  reducers: {
    SellerLoginRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    SellerLoginSuccess: (state, action) => {
      state.loading = false;
      state.Seller = action.payload;
    },
    SellerloginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { SellerLoginRequest, SellerLoginSuccess, SellerloginFailure } =
  loginsclice.actions;

export default loginsclice.reducer;
